export const style = {
  container: {
    padding: "2.4rem 1.2rem",
    width: "100%",
  },
  heading: {
    color: "var(--black-900)",
    fontSize: "2rem",
    fontWeight: 500,
    lineHeight: "normal",
  },
  clinicNameOrPlatform: {
    color: "var(--black-900)",
    fontSize: "1.6rem",
    fontWeight: 400,
    lineHeight: "normal",
  },
  totalBookedContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    marginTop: "0.8rem",
  },
  slotContainer: {
    padding: "0.4rem 0.8rem",
    borderRadius: "1.5rem",
    background: "var(--gray-20)",
    "& > p": {
      color: "var(--gray-400)",
      fontSize: "1.4rem",
      fontWeight: 400,
    },
  },
  totalBooked: {
    color: "var(--gray-400)",
    fontSize: "1.4rem",
    fontWeight: 400,
  },
  appointmentTimeRangeContainer: {
    marginTop: "0.8rem",
    "& > p": {
      color: "var(--gray-400)",
      fontSize: "1.2rem",
      fontWeight: 400,
    },
  },
  blockBookingForChipContainer: {
    marginTop: "0.8rem",
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
    "& > p": {
      color: "var(--black-900)",
      fontSize: "1.4rem",
      fontWeight: 400,
    },
  },
  editAvailabilityButtonContainer: {
    marginTop: "1.6rem",
    display: "flex",
    justifyContent: "space-between",
    gap: "1.6rem",
  },
  blockBookingForChipLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  blockBookingForChipText: {
    color: "var(--black-900)",
    fontSize: "1.2rem",
    fontWeight: 400,
    textTransform: "capitalize",
  },
  blockBookingContainer: { display: { xs: "none", lg: "block" } },
  blockBookingButtonContainer: {
    width: "100%",
    display: { xs: "block", lg: "none" },
  },
  blockedBookingHeadingContainer: {
    marginTop: "1.6rem",
    "& > h5": {
      color: "var(--gray-400)",
      fontSize: "1.2rem",
      fontWeight: 400,
    },
  },
  blockBookingForChip: {
    backgroundColor: "var(--gray-20)",
    color: "var(--black-900)",
    fontSize: "1.2rem",
    fontWeight: 400,
    textTransform: "capitalize",
  },
  blockedBookingContainer: {
    padding: "1.6rem",
    display: "flex",
    flexDirection: "column",
    gap: "1.6rem",
  },
  blockedBookingHeadingBoxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.4rem",
  },
  blockedBookingHeading: {
    color: "var(--black-900)",
    fontSize: "1.6rem",
    fontWeight: 400,
  },
  blockedBookingHeadingInnerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.4rem",
  },
  blockedBookingHeadingInnerText: {
    color: "var(--gray-700)",
    fontSize: "1.6rem",
    fontWeight: 600,
  },
  blockedBookingHeadingDateText: {
    color: "var(--gray-400)",
    fontSize: "1.4rem",
    fontWeight: 400,
  },
};
